import React from 'react';
import { X } from 'lucide-react';
import { FilterState } from './types';

// Filter pill rows grouped by category, with a category label on the left.
// Matches the established FilterPills pattern (DataView v1 / LibraryView),
// kept as its own component so every domain tab shares it.

interface Props {
  filters: Record<string, string[]>;
  activeFilters: FilterState;
  onToggle: (category: string, value: string) => void;
  onClear: () => void;
}
export function FilterPills({
  filters,
  activeFilters,
  onToggle,
  onClear
}: Props) {
  const hasActive = Object.values(activeFilters).some(v => v.length > 0);
  return <div className="flex flex-wrap items-center gap-x-6 gap-y-3 mb-5" data-id="element-740">
      {Object.entries(filters).map(([category, values]) => <div key={category} className="flex items-center gap-2 flex-wrap" data-id="element-741">
          <span className="text-[11px] text-[#8a8680]/50 uppercase tracking-wider" data-id="element-742">{category}</span>
          {values.map(value => {
        const active = (activeFilters[category] || []).includes(value);
        return <button key={value} onClick={() => onToggle(category, value)} className={`text-[12px] px-2.5 py-1 rounded-full transition-colors ${active ? 'bg-[#4a9a9a]/20 text-[#4a9a9a]' : 'bg-[#252530] text-[#8a8680] hover:text-[#e8e4df]'}`} data-id="element-743">
                {value}
                {active && <X size={10} className="inline ml-1.5 -mt-0.5" data-id="element-744" />}
              </button>;
      })}
        </div>)}
      {hasActive && <button onClick={onClear} className="text-[12px] text-[#8a8680]/60 hover:text-[#e8e4df] transition-colors underline underline-offset-2" data-id="element-745">
          Clear filters
        </button>}
    </div>;
}